const getDefaultSetTimeout = () =>
  typeof setTimeout === 'function' ? setTimeout : null;

const getDefaultDocument = () =>
  typeof document !== 'undefined' ? document : null;

const getDefaultUrlObject = () => (typeof URL !== 'undefined' ? URL : null);

const getDefaultBlob = () => (typeof Blob !== 'undefined' ? Blob : null);

export const isBlobObject = (value, blobConstructor = getDefaultBlob()) =>
  Boolean(blobConstructor && value instanceof blobConstructor);

export const createObjectUrl = (value, urlObject = getDefaultUrlObject()) => {
  if (!value || typeof urlObject?.createObjectURL !== 'function') {
    return '';
  }

  try {
    return urlObject.createObjectURL(value) || '';
  } catch (_) {
    return '';
  }
};

export const revokeObjectUrl = (
  url = '',
  urlObject = getDefaultUrlObject()
) => {
  if (!url || typeof urlObject?.revokeObjectURL !== 'function') {
    return false;
  }

  try {
    urlObject.revokeObjectURL(url);
    return true;
  } catch (_) {
    return false;
  }
};

export const revokeObjectUrlLater = (
  url = '',
  delay = 0,
  {
    setTimeoutFn = getDefaultSetTimeout(),
    urlObject = getDefaultUrlObject(),
  } = {}
) => {
  if (!url) {
    return null;
  }

  if (typeof setTimeoutFn !== 'function') {
    revokeObjectUrl(url, urlObject);
    return null;
  }

  try {
    return setTimeoutFn(() => {
      revokeObjectUrl(url, urlObject);
    }, delay);
  } catch (_) {
    revokeObjectUrl(url, urlObject);
    return null;
  }
};

export const downloadObjectUrl = ({
  documentObject = getDefaultDocument(),
  fileName = '',
  object,
  revokeDelay = 1000,
  setTimeoutFn = getDefaultSetTimeout(),
  urlObject = getDefaultUrlObject(),
} = {}) => {
  const url = createObjectUrl(object, urlObject);

  if (!url || typeof documentObject?.createElement !== 'function') {
    revokeObjectUrl(url, urlObject);
    return null;
  }

  const link = documentObject.createElement('a');
  link.href = url;
  link.download = fileName;

  try {
    documentObject.body?.appendChild?.(link);
    link.click?.();
    documentObject.body?.removeChild?.(link);
  } finally {
    revokeObjectUrlLater(url, revokeDelay, { setTimeoutFn, urlObject });
  }

  return link;
};
